import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  MUIDataTable,
  MUIDataTableColumn,
  Typography,
  useDataTable,
} from 'web-library';
import DialogTitle from '@mui/material/DialogTitle';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { CandidateListBase } from '../../../api-refactored/group-exam-registration/model';
import { ClassesAndTranslation } from '../../../models/ClassesAndTranslation';
import useDataTableFEPagination from '../../../hooks/useDataTableFEPagination';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
export interface IViewCandidatesListDialogData {
  candidateList: CandidateListBase[];
  subjectName: string;
  subjectCode: string;
}

export interface IViewCandidatesListDialog {
  data: IViewCandidatesListDialogData;
  onClose: () => void;
}

const useStyles = makeStyles()((theme) =>
({
  dialog: {
    overflow: 'hidden',
  },
  viewDetailsDialog: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      '&.MuiDialog-paper': {
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        '& .MuiDialogTitle-root': {
          padding: 0,
        },
        '& .MuiDialogContent-root': {
          padding: 0,
        },
        '& .MuiDialogActions-root': {
          padding: 0,
        },
      },
    },
  },
  // Mui DataTable css starts
  datatable: {
    marginBottom: theme.spacing(4),
    '& .MuiTableRow-root': {
      borderBottom: `1px solid ${theme.color.border.borderFocused} !important`,
    },
  },
  subject: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
  },
  subjectName: {
    paddingBottom: theme.spacing(1),
  },
  optionalPaper: {
     ...typographyTheme(theme, 'subtitle2'),
    color: theme.color.text.textSecondary,
  },
  gridContainer: {
    marginBottom: theme.spacing(4),
  },
  feeCell: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  // Mui DataTable css ends
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    alignItems: 'center',
  },
  closeButton: {
    padding: 0,
  },
}));

const candidateListColumns = ({ t }: ClassesAndTranslation): MUIDataTableColumn[] => [
  {
    name: 'uinFinPassport',
    label: t('exam->>ReviewExam.NRIC/FIN/Passport No.'),
    options: {
      setCellProps: () => ({ style: { width: '20%' } }),
    },
  },
  {
    name: 'candidateName',
    label: t('exam->>ReviewExam.CandidateName'),
  },
];

const ViewCandidatesListDialog = ({ data, onClose }: IViewCandidatesListDialog) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const { candidateList, subjectName, subjectCode } = data;
  const { state: tableState, dispatch: tableDispatch } = useDataTable();
  useDataTableFEPagination({ dataList: candidateList, tableDispatch, tableState });
  const handleClose = () => {
    onClose();
  };
  return (
    (<Dialog
      className={classes.viewDetailsDialog}
      onClose={handleClose}
      open={!!subjectName && !!subjectCode && candidateList.length > 0}
      maxWidth="lg"
      PaperProps={{ className: classes.dialog }}
    >
      <Box className={classes.titleContainer}>
        <DialogTitle>
          <Typography variant="h4">
            {t('exam->>ReviewExam.CandidatesTaking', { subjectName, subjectCode })}
          </Typography>
        </DialogTitle>
        <IconButton
          className={classes.closeButton}
          name={IconName.cross}
          iconSize="M"
          color={theme.color.icon.iconDefault}
          ariaLabel="view-fee-detail-close"
          onClick={handleClose} />
      </Box>
      <DialogContent>
        <Box className={classes.datatable}>
          <MUIDataTable
            columns={candidateListColumns({
              t,
              classes,
            })}
            data={tableState.data}
            dispatch={tableDispatch}
            state={tableState}
            options={{
              pagination: true,
            }}
            rowsPerPageOptions={[5, 10, 20, 30, 50]}
          />
        </Box>
      </DialogContent>
    </Dialog>)
  );
};

export default ViewCandidatesListDialog;
